import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'referrer',
})
export class ReferrerPipe implements PipeTransform {
  transform(value: string): string {
    const lang = localStorage.getItem('ngx-webstorage|pinploy_lang');
    const language = JSON.parse(lang);
    if (language?.value === 'dk') {
      if (value === 'to') {
        value = 'Opgave ejer';
      } else if (value === 'hh') {
        value = 'Handyhander';
      } else {
        value = 'Opgave ejer og Handyhander';
      }
    } else if (value === 'to') {
      value = 'Task owner';
    } else if (value === 'hh') {
      value = 'Handyhander';
    } else {
      value = 'Task owner and Handyhander';
    }

    return value;
  }
}
